import { render, staticRenderFns } from "./Memory.ts.vue?vue&type=template&id=3917750e&"
import script from "./Memory.ts.vue?vue&type=script&lang=ts&"
export * from "./Memory.ts.vue?vue&type=script&lang=ts&"
import style0 from "./Memory.ts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports